import useFetch from 'use-http';
import { API_ROUTES } from '../../constants';

import {
  TAPIUpdateApplicationResponse,
} from './update-aplications.types';

export const useAPIFetchPutApplication = (id:string): TAPIUpdateApplicationResponse => {
  const { put, error, loading, response, data={} } = useFetch(`${API_ROUTES.APPLICATIONS}/${id}`);

  async function fetchPutApplication(body: any): Promise<void> {
     await put(body);
  }

  return {
    data,
    loading,
    error,
    loaded: response.ok,
    fetchPutApplication,
  };
};
